import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Hero.css";

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 3000,
      once: true, // Ensures animations run only once
    });
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Welcome Title */}
        <h2
          className="hero-welcome-title"
          data-aos="fade-up"
          data-aos-anchor-placement="center-center"
        >
          Welcome to <br />
        </h2>

        {/* Main Title */}
        <h1 className="hero-title" data-aos="fade-right">
          AL-NISA QURAN <br /> INSTITUTE
        </h1>

        {/* Description */}
        <p
          className="hero-description"
          onDurationChange={3000}
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
          style={{ fontSize: "20px" }}
        >
          Al-Nisa Online Quran Academy is dedicated to offering comprehensive
          Quranic <br /> education worldwide, embracing inclusivity at every
          level.
        </p>

        {/* Buttons */}
        <div
          className="hero-buttons"
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <Link to="/About" className="hero-button primary-button">
            Learn More
          </Link>
          <Link to="/Contact" className="hero-button secondary-button">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
